var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeezerLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 580,
    height: 114,
    viewBox: "0 0 580 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115.35 36.52H90.5195V51.01H115.35V36.52Z",
    fill: "#29AB70"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M115.35 56.7H90.5195V71.19H115.35V56.7Z",
    fill: "url(#paint0_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M115.35 76.87H90.5195V91.36H115.35V76.87Z",
    fill: "url(#paint1_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3398 97.05H0.509766V111.54H25.3398V97.05Z",
    fill: "url(#paint2_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3398 97.05H30.5098V111.54H55.3398V97.05Z",
    fill: "url(#paint3_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3495 97.05H60.5195V111.54H85.3495V97.05Z",
    fill: "url(#paint4_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M115.35 97.05H90.5195V111.54H115.35V97.05Z",
    fill: "url(#paint5_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3495 76.87H60.5195V91.36H85.3495V76.87Z",
    fill: "url(#paint6_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3398 76.87H30.5098V91.36H55.3398V76.87Z",
    fill: "url(#paint7_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3398 56.7H30.5098V71.19H55.3398V56.7Z",
    fill: "url(#paint8_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M335.461 95.79C324.691 95.79 315.831 89.3 315.671 77.9H366.671C367.339 74.8859 367.675 71.8074 367.671 68.72C367.671 48.13 353.581 34.99 332.841 34.99C310.671 34.99 295.471 52.25 295.471 73.62C295.471 97.37 311.941 113.21 335.211 113.21C352.791 113.21 364.981 104.34 370.211 89.77L352.881 83C350.501 91.52 344.641 95.79 335.461 95.79ZM332.771 51.3C341.771 51.3 347.971 56.21 347.971 63.81L347.811 64.44H315.671C317.571 56.21 324.541 51.3 332.771 51.3V51.3Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M437.73 53.2001V36.5701H372.34V53.9901H412.24L371.07 94.2101V111.62H438.84V93.4101H396.4L437.73 53.2001Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M559.86 60.8C559.866 62.061 559.782 63.3208 559.61 64.57H578.82C579.287 62.128 579.511 59.646 579.49 57.16C579.49 44.33 571.42 34.99 557.96 34.99C549.25 34.99 543.08 39.27 539.91 46.23V36.58H519.65V111.58H539.91V63.33C539.91 55.73 544.03 51.46 550.36 51.46C556.06 51.46 559.86 55.26 559.86 60.8Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M194.999 47.82C190.399 40.06 181.849 34.99 171.249 34.99C150.659 34.99 135.619 50.83 135.619 74.42C135.619 97.69 150.509 113.21 171.719 113.21C182.329 113.21 190.879 108.61 195.789 100.86V111.62H215.259V0.790039H194.999V47.82ZM175.829 96C164.589 96 155.829 87.77 155.829 74.47C155.829 61.01 164.539 52.47 175.829 52.47C186.749 52.47 195.779 61.02 195.779 74.47C195.779 87.72 186.749 96 175.829 96Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M479.81 95.79C469.04 95.79 460.18 89.3 460.02 77.9H511.02C511.689 74.8859 512.024 71.8074 512.02 68.72C512.02 48.13 497.93 34.99 477.19 34.99C455.02 34.99 439.82 52.25 439.82 73.62C439.82 97.37 456.29 113.21 479.56 113.21C497.14 113.21 509.33 104.34 514.56 89.77L497.22 83C494.85 91.52 489 95.79 479.81 95.79ZM477.12 51.3C486.12 51.3 492.32 56.21 492.32 63.81L492.16 64.44H460C461.92 56.21 468.88 51.3 477.12 51.3V51.3Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M260.63 95.79C249.86 95.79 241 89.3 240.84 77.9H291.84C292.497 74.8848 292.815 71.8058 292.79 68.72C292.79 48.13 278.7 34.99 257.96 34.99C235.79 34.99 220.59 52.25 220.59 73.62C220.59 97.37 237.06 113.21 260.33 113.21C277.91 113.21 290.1 104.34 295.33 89.77L278.05 83C275.67 91.52 269.81 95.79 260.63 95.79ZM257.94 51.3C266.94 51.3 273.14 56.21 273.14 63.81L272.98 64.44H240.84C242.74 56.21 249.71 51.3 257.94 51.3V51.3Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 104.55,
    y1: 73.09,
    x2: 101.32,
    y2: 54.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C8C9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#298E9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#129C83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#05A475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A770"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 90.1495,
    y1: 90.63,
    x2: 115.72,
    y2: 77.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2839BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#148CB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 0.509766,
    y1: 104.29,
    x2: 25.3398,
    y2: 104.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6A500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F29100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 30.5098,
    y1: 104.29,
    x2: 55.3398,
    y2: 104.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F29100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D12F5F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 60.5195,
    y1: 104.29,
    x2: 85.3495,
    y2: 104.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4197C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#472EAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 90.5195,
    y1: 104.29,
    x2: 115.35,
    y2: 104.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2839BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3072B7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 59.5395,
    y1: 88.03,
    x2: 86.3195,
    y2: 80.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4197C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#373AAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 29.6398,
    y1: 79.28,
    x2: 56.2198,
    y2: 88.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCB00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D12F5F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 32.6098,
    y1: 54.4199,
    x2: 53.2398,
    y2: 73.4599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED743B"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeezerLogo);
export default __webpack_public_path__ + "static/media/deezer_logo.28f4d2c4.svg";
export { ForwardRef as ReactComponent };